import { ArticleHeading2, ArticleParagraph2, Label } from '@cian/ui-kit';
import { memo } from 'react';

import styles from './Price.css';
import { IDiscount } from '../../types';
import { ContentRow } from '../ContentRow';
import { GeneralInfoSectionRow } from '../GeneralInfoSectionRow';

interface IPriceProps {
  priceInfo?: string;
  price: string;
  discount?: IDiscount;
}

export const Price = memo<IPriceProps>(function Price({ priceInfo, price, discount }) {
  return (
    <GeneralInfoSectionRow>
      <ContentRow>
        {discount ? (
          <div className={styles['price-container']} data-testid="offer-discount-block">
            <ArticleHeading2>
              <span data-testid="offer-discount-new-price">{discount.newPrice}</span>
            </ArticleHeading2>
            <Label background="#EBF9E6" color="#34AC0A" data-testid="offer-discount-label">
              {discount.percent}
            </Label>
            <span className={styles['strikethrough']} data-testid="offer-discount-old-price">
              {price}
            </span>
          </div>
        ) : (
          <ArticleHeading2 data-mark="MainPrice">
            <span>{price}</span>
          </ArticleHeading2>
        )}
      </ContentRow>
      {priceInfo && (
        <ContentRow>
          <ArticleParagraph2 data-mark="PriceInfo" color="gray60_100">
            {priceInfo}
          </ArticleParagraph2>
        </ContentRow>
      )}
    </GeneralInfoSectionRow>
  );
});
